import { render, staticRenderFns } from "./NuevoContacto.vue?vue&type=template&id=66d53c89"
import script from "./NuevoContacto.vue?vue&type=script&lang=js"
export * from "./NuevoContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports